import { HotmartRum } from '@hot-observability-js/vue'
import Vue from 'vue'
import pkjson from '../../../package.json'

const initSentry = () => {
  HotmartRum.init({
    Vue,
    release: `${pkjson.name}@${pkjson.version}`,
    dsn: 'https://41d4290d10cdef0a04d4117da7127f19@o49094.ingest.us.sentry.io/4506937699008512',
    instanceName: 'app-refund',
    environment: process.env.NODE_ENV === 'production' ? 'production' : 'staging',
  })
}

const setUser = (id = '', email = '') => {
  HotmartRum.setUser({
    id,
    email,
  })
}

export { initSentry, setUser }
